import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { PLACE_ORDER_MAX_DECIMALS } from './buySellTab.constants';

export const wrapDisabledActionTooltip = (
  node,
  tooltipText,
  tooltipId = 'send-order-disabled-reason',
) => {
  const text = String(tooltipText ?? '').trim();
  if (!text) return node;

  return (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      delay={{ show: 200, hide: 100 }}
      overlay={(overlayProps) => (
        <Tooltip
          {...overlayProps}
          id={tooltipId}
          className="buySelltab__disabledActionTooltip tooltip"
        >
          {text}
        </Tooltip>
      )}
    >
      <span
        className="d-inline-block w-100 buySelltab__disabledActionTrigger"
        tabIndex={0}
        aria-disabled="true"
      >
        {node}
      </span>
    </OverlayTrigger>
  );
};

export const getPlaceOrderInputDecimals = (pairDecimal) => {
  const d = Number(pairDecimal);
  if (!Number.isFinite(d) || d <= 0) return PLACE_ORDER_MAX_DECIMALS;
  return Math.min(d, PLACE_ORDER_MAX_DECIMALS);
};

export const getSubmitDecimalPlaces = (pairDecimal) => {
  const d = Number(pairDecimal);
  if (!Number.isFinite(d) || d <= 0) return PLACE_ORDER_MAX_DECIMALS;
  return d;
};
